module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 2
// module chunks = 0 3 4 6 7 8 10 12 16 17 18 20 21 23 24 25 26 30 31 32 33 34 36 39 41 42 43 44 46 48 49 51 52 56 64 65 77 78 79 82 85 87 93 94 95 99 100 101 103 104 105 106 108 109 110 111 112 113 114 115 118 120 123 142 143 147 148 157 158 159 164 170 171 172 173 174